// Borrowed from: https://git.hubteam.com/HubSpot/apollo-link-hub-http/blob/master/static/js/internal/stableStringify.ts#L1

const stableCopy = value => {
  if (!value || typeof value !== 'object') {
    return value;
  }
  if (Array.isArray(value)) {
    return value.map(stableCopy);
  }
  const keys = Object.keys(value).sort();
  const stable = {};
  for (let i = 0; i < keys.length; i++) {
    stable[keys[i]] = stableCopy(value[keys[i]]);
  }
  return stable;
};
const stableStringify = value => {
  return JSON.stringify(stableCopy(value));
};
const hashCode = s =>
// eslint-disable-next-line no-bitwise
s.split('').reduce((a, b) => (a << 5) - a + b.charCodeAt(0) | 0, 0);
export const createRequestName = (details, request) => {
  const stableString = stableStringify({
    rpcName: details.rpcName,
    serviceName: details.serviceName,
    fingerprint: details.fingerprint,
    request: request !== null && request !== void 0 ? request : {}
  });
  return hashCode(stableString).toString();
};